export const DATA_FIRESTORE_V01_EVENT_WAITLIST = {
  NAME: 'v01_event_waitlist',
}
